import { z } from "zod";

import { ResponseToVhRequestDocumentType } from "@/src/models/constants/document-types";
import { Specialty } from "@/src/models/constants/specialty";
import { DatabaseDefaults } from "@/src/models/database-defaults";
import { DocumentDateSchema } from "@/src/models/documents/document-dates";
import { Patient, patientMinimalSchema } from "@/src/models/patient";

export const responseToVhRequestTypeDisplay: Record<ResponseToVhRequestDocumentType, string> = {
  [ResponseToVhRequestDocumentType.RESPONSE_TO_VH_REQUEST]: "Response to VH Request",
};

export const responseToVhRequestTypeSchema = z.nativeEnum(ResponseToVhRequestDocumentType);

export const responseToVhRequestSchema = z.object({
  type: responseToVhRequestTypeSchema,
  specialty: z.nativeEnum(Specialty).nullable(),
  patient: patientMinimalSchema,
  ...DocumentDateSchema.shape,
});

export type ResponseToVhRequest = Omit<z.infer<typeof responseToVhRequestSchema>, "patient"> & {
  patient: Patient | null;
} & DatabaseDefaults;

export const responseToVhRequestShape: ResponseToVhRequest = {
  id: "",
  type: ResponseToVhRequestDocumentType.RESPONSE_TO_VH_REQUEST,
  patient: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
  specialty: null,
  dateOfDocument: null,
  dateReceived: null,
  dateSigned: null,
  dateOfEvent: null,
};
